import React, { useEffect, useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import CardSection from 'components/sales/cardSection/cardSection';

const ScannerTest = ({
  history,
  match
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState(null);
  const handleMessageFromReactNative = (event) => {
    const dataFromReactNative = event.data;
    console.log("Data received from React Native:", dataFromReactNative);
    setData(dataFromReactNative);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessageFromReactNative);
  }, []);

  const openScanner = () => {
    const RNWebView = window?.ReactNativeWebView;
    if (RNWebView) {
      const contentStr = {
        event: "OPEN_BAR_CODE_SCANNER",
        data: null,
        os: "ANDROID"
      };
      RNWebView.postMessage(JSON.stringify(contentStr));
    }
  };

  console.log('PAGE :: SCANNER TESTING');
  return (
    <Layout
      title={`Scanner Test`}
      isLoading={isLoading}
      isGoback
    >
     <CardSection title={'Scanner'} >
      <div className="App">
        <h1>Scanner</h1>
        <h2 id="MSG">Message</h2>
        <pre>{JSON.stringify(data)}</pre>
        <button className='btn btn-primary' onClick={openScanner}>Open Scanner</button>
      </div>
     </CardSection>
    </Layout>
  );
};

export default ScannerTest;
